<style lang="scss">
  @use "../../../../assets/css/design-system/colors";
  @use "../../../../assets/css/design-system/utils";
  @use "../../../../assets/css/design-system/mixins";

  .usage {
    height: utils.in_rem(20px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.25rem;
    @include mixins.body4();
    display: flex;
    padding-bottom: utils.in_rem(6px);
    .active {
      @include colors.color(chartGood);
    }
    .disabled {
      @include colors.color(chartGood);
    }

    .status-text {
      @include mixins.body3();
      color: colors.get(textBlack);
    }
    .text {
      @include mixins.h5();
      text-align: right;
    }
  }
</style>

<script>
  import Icon from "../../../atoms/Icon.svelte";

  let { status } = $props();
  let active = $derived(status === "active");
  let disabled = $derived(status !== "active");
  let icon = $derived(
    active ? "fa-regular fa-check-circle" : "fa-regular fa-xmark"
  );
</script>

<div class="usage">
  <div class="active-info">
    <span class:active class:disabled>
      <Icon size="xs" class={icon} />
    </span>
    <span class="status-text">
      {status === "active" ? "Enabled" : "Disabled"}
    </span>
  </div>
  <span class="text"> Team License </span>
</div>
